import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useParams, Navigate } from 'react-router-dom';
import './App.scss';
import { setMode } from './actions';
import Nav from './components/navMenu/Nav';
import ToggleBar from './components/toggleBar/ToggleBar';
import HomePage from './components/homePage/HomePage';
import AboutPage from './components/aboutPage/AboutPage';
import ProjectsPage from './components/projectsPage/ProjectsPage';
import ContactPage from './components/contactPage/ContactPage';
import LenisScroll from './components/lenisScroll/LenisScroll';

function App() {
  const { mode } = useParams();
  const dispatch = useDispatch();

  const isValidMode = mode === 'dev' || mode === 'designer';
  const isDev = mode !== 'designer';

  // keep redux state and the body theme class in sync with the URL (/dev | /designer)
  useEffect(() => {
    if (!isValidMode) return;
    dispatch(setMode(isDev));
    document.body.classList.toggle('designMode', !isDev);
  }, [isValidMode, isDev, dispatch]);

  // unknown paths (e.g. /foo) fall back to the developer portfolio
  if (!isValidMode) return <Navigate to="/dev" replace />;

  return (
    <div className="App">
      <LenisScroll />
      <Nav />
      <ToggleBar />
      <HomePage />
      <AboutPage />
      <ProjectsPage />
      <ContactPage />
    </div>
  );
}

export default App;